module.exports = __webpack_public_path__ + "img/title2.50a80aab.png";